import type { SearchConfig } from '@eliadmin/core/src/components/header/search-bar/search-config-types';

export const SEARCH_CONFIG: SearchConfig = {
  mode: 'drawer',
  field: {
    placeholder: 'Aký produkt hľadáte?',
    buttonTextKey: 'text1',
    buttonClassName: 'h-10 w-auto rounded-full border-none px-4',
  },
};
